import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Card, CardActions, CardContent, CircularProgress, TextField } from '@mui/material';
import { AppPage, AppToast, ImplicitSubmit } from '@shared';
import { uidMaxLength } from 'utils';
import axios from '@utils/axios-rails';

const propTypes = {
  submitURL: PropTypes.string.isRequired,
}

const CourierLogin = (props) => {
  const [form, setForm] = useState({
    uid: "",
    national_id: ""
  })

  const [toast, setToast] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (value, id) => {
    setForm({
      ...form,
      [id]: value
    });
  }

  const handleSubmit = async () => {
    setLoading(true);
    const response = await axios.post(props.submitURL, {
      ...form
    });
    let data = response.data;
    try {
      if (data.success) {
        setToast(I18n.t("devise.sessions.signed_in"));
        window.location = data.redirectURL;
        return true;
      }
      else{
        setToast(I18n.t("messages.courier_login_invalid"));
      }
    } catch (error) {
      setToast("messages.request_error")
    }
    setLoading(false);
  }

  const onDismiss = () => setToast("");

  return(
        <AppPage title={ I18n.t("app.sign_in") }>
          <div>
            <Card>
              <CardContent>
              <form onSubmit={(event) => { event.preventDefault(); handleSubmit(); }}>
                <TextField
                  fullWidth
                  margin="normal"
                  id="national_id"
                  value={form.national_id}
                  label={ I18n.t("activerecord.attributes.courier.national_id") }
                  placeholder={"0000"}
                  onChange={(event) => handleChange(event.target.value, "national_id")}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  fullWidth
                  margin="normal"
                  id="uid"
                  value={form.uid}
                  label={ I18n.t("activerecord.attributes.courier.uid") }
                  placeholder={"0000"}
                  onChange={(event) => handleChange(event.target.value, "uid")}
                  inputProps={{ maxLength: uidMaxLength }}
                  InputLabelProps={{ shrink: true }}
                />
                <ImplicitSubmit />
              </form>
              </CardContent>

              <CardActions sx={{ justifyContent: 'flex-end' }}>
                <Button
                  variant="contained"
                  disabled={loading}
                  startIcon={ loading ? <CircularProgress size={16} color="inherit" /> : null }
                  onClick={handleSubmit}
                >
                  { I18n.t("actions.submit") }
                </Button>
              </CardActions>
            </Card>
            { !!toast ? <AppToast content={toast} onDismiss={onDismiss} />  : null }
          </div>
        </AppPage>
  )
}

CourierLogin.propTypes = propTypes;

export default CourierLogin;